import styled from 'styled-components'

export const NoDataBoxContainer = styled.div`
    text-align: center;
    font-size: 1.4rem;
    font-weight: 300;
    color: #b9bcc1;
    padding: 80px 0;
    line-height: 1.5;
    img {
        margin: 0 auto;
        width: 32px;
        height: 45px;
        aspect-ratio: 32/45;
        margin-bottom: 24px;
    }
`
